import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { ActivityType } from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/activity-type';
import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import { ProjectWindowComponent } from '../project-window/project-window.component';
import { MatDialog } from '@angular/material/dialog';
import { getValue, upperCaseValue, capitalizeCaseValue } from 'projects/core/src/public-api';
import * as moment from 'moment';
import { ProjectsQuery } from 'projects/app-misc/src/app/modules/project-misc/data/project/projects.query';
import { Table } from 'primeng/table';
import { debounceTime } from 'rxjs/operators';
import { timer } from 'rxjs';
import {Router} from '@angular/router';

class TableColumnDef {
  field: string
  header: string
  type?: 'Date' | 'number' | 'customer'
  renderer?: any
}

@Component({
  selector: 'app-projects-list',
  templateUrl: './projects-list.component.html',
  styleUrls: ['./projects-list.component.scss']
})
export class ProjectsListComponent implements OnInit, AfterViewInit {
  cols: TableColumnDef[];

  types: ActivityType[] = [];

  loadingProjects = true;

  projectsPerPage = 15;

  colsForSearch = [];

  projects$ = this.projectsQuery.selectAll()
  totalElements$ = this.projectsQuery.totalElements

  totalElements: number;
  first: number;
  rows: number;
  footerString: string;

  sortMap = new Map();

  @ViewChild('dt', {static: true})
  table: Table;

  sortLabel: string;
  asc = 0;

  constructor(
    public router: Router,
    protected el: ElementRef,
    protected dialog: MatDialog,
    protected projectService: ProjectService,
    protected projectActivityService: ProjectActivityService,
    protected projectsQuery: ProjectsQuery
  ) {
    this.cols = [
      {field: 'name', header: 'Name', renderer: upperCaseValue},
      {field: 'customer.name', header: 'Customer', renderer: capitalizeCaseValue},
      {field: 'machiningDate', header: 'Date Machining', type: 'Date'},
      {field: 'jobDeliveryDate', header: 'Date Delivery', type: 'Date'}
    ];
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    timer(1).subscribe(emit => {
      this.projectsPerPage = Math.max(this.projectsPerPage, Math.trunc((this.el.nativeElement.offsetHeight - 150) / 35));

      this.loadNewProjects(0, this.projectsPerPage);

      this.countCols();

      this.nullifyMap();

      this.getActivityTypes();
    })
  }

  countCols() {
    this.cols.forEach(col => {
      this.colsForSearch.push(col.field)
    })
  }

  countFooter() {
    let max = this.projectsPerPage * (this.first / this.rows + 1);
    max = max < this.totalElements ? max : this.totalElements;

    this.footerString = `${this.first + 1} to ${max} of ${this.totalElements}`;
    // if()
  }

  openProject(event: any) {
    this.openProjectWindow(event.data)
  }

  loadProjectsLazy(event: any) {
    this.loadNewProjects(event.first, event.rows);
  }

  loadNewProjects(start: number, limit: number) {
    this.first = start;
    this.rows = limit;

    this.loadingProjects = true
    this.projectsQuery.selectLoading().subscribe()

    // //TODO MAKE THIS THROUGH AKITA
    this.totalElements$.pipe(debounceTime(500)).subscribe(totals => {
      this.totalElements = totals;
    })

    if(this.asc > 0) {
      this.loadSorted(start, limit)
    } else {
      this.loadDefault(start, limit)
    }
  }

  loadDefault(start: number, limit: number) {
    this.projectService.loadProjects(start / limit, limit).subscribe(page => {
      this.totalElements = page.totalElements;

      this.loadingProjects = false;
      this.countFooter();
    });
  }

  loadSorted(start: number, limit: number) {
    let ascBoolean = true;

    if(this.asc === 2) ascBoolean = false;

    this.projectService.loadSortProjects(start / limit, limit, ascBoolean, this.sortLabel).subscribe(page => {
      this.loadingProjects = false;
      this.countFooter();
    });

  }

  openProjectWindow(project: Project) {
    const dialogRef = this.dialog.open(ProjectWindowComponent, {
      data: {
        projectNumber: project.id,
      },
      panelClass: 'project-window-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  getActivityTypes() {
    this.projectActivityService.getActivityTypes()
    .subscribe(types => {
      this.types = types
    })
  }

  getFieldData(rowData: any, col: TableColumnDef) {
    let value = getValue(rowData, col.field)
    if(col.type === 'Date' && value) {
      value = moment(value).format('ll');
    } else if(col.type === 'number') {
      value = Math.round(value * 100) / 100
    }

    if(col.renderer) {
      value = col.renderer(value)
    }
    // if col has renderer, then apply this renderer to value

    return value
  }

  nullifyMap() {
    this.sortMap.set('name', 0);
    this.sortMap.set('customer.name', 0);
    this.sortMap.set('machiningDate', 0);
    this.sortMap.set('jobDeliveryDate', 0);
  }

  countMap(param: string) {
    let num = this.sortMap.get(param);

    this.sortLabel = param;
    if(num === 1) {
      num++;
      this.asc = num
    } else if(num === 0) {
      this.nullifyMap();
      num++;
      this.asc = num
      this.table.reset();
    } else if(num === 2) {
      num = 0;
      this.asc = num
    }

    this.sortMap.set(param, num);
  }

  sortByHeader(header: string) {
    if(!this.loadingProjects) {
      this.countMap(header);

      if(this.sortMap.get(header) === 0) {
        this.table.reset();
        return
      }

      this.loadSorted(0, this.projectsPerPage)
    }
  }
}
